import Icon from "@ant-design/icons";
import React from "react";

export default function MapWithPinIcon() {
  return <Icon className="ac-icon" component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6154 10.0922C14.02 9.80706 15.0771 8.56528 15.0771 7.07659C15.0771 5.37714 13.6995 3.99946 12 3.99946C10.3005 3.99946 8.92287 5.37714 8.92287 7.07659C8.92287 8.56528 9.98002 9.80706 11.3846 10.0922V13.6411C11.3846 13.981 11.6601 14.2566 12 14.2566C12.3399 14.2566 12.6154 13.981 12.6154 13.6411V10.0922ZM10.1537 7.07659C10.1537 6.05692 10.9803 5.23031 12 5.23031C13.0197 5.23031 13.8463 6.05692 13.8463 7.07659C13.8463 8.09626 13.0197 8.92287 12 8.92287C10.9803 8.92287 10.1537 8.09626 10.1537 7.07659Z"
        fill="currentColor"
      />
      <path
        d="M7.07715 12.6154C6.58821 12.6154 6.16725 12.9605 6.07136 13.44L5.25079 17.5428C5.19052 17.8441 5.26854 18.1566 5.46336 18.3943C5.65818 18.6319 5.94929 18.7697 6.25658 18.7697H17.7434C18.0507 18.7697 18.3418 18.6319 18.5366 18.3943C18.7315 18.1566 18.8095 17.8441 18.7492 17.5428L17.9286 13.44C17.8328 12.9605 17.4118 12.6154 16.9229 12.6154H15.2823C14.9424 12.6154 14.6668 12.3399 14.6668 12C14.6668 11.6601 14.9424 11.3846 15.2823 11.3846H16.9229C17.9985 11.3846 18.9246 12.1438 19.1356 13.1986L19.9562 17.3014C20.0887 17.9644 19.9171 18.6518 19.4885 19.1746C19.0599 19.6974 18.4195 20.0005 17.7434 20.0005H6.25658C5.58053 20.0005 4.9401 19.6974 4.51149 19.1746C4.08288 18.6518 3.91126 17.9644 4.04384 17.3014L4.86441 13.1986C5.07536 12.1438 6.00149 11.3846 7.07715 11.3846H8.71773C9.05762 11.3846 9.33315 11.6601 9.33315 12C9.33315 12.3399 9.05762 12.6154 8.71773 12.6154H7.07715Z"
        fill="currentColor"
      />
      <path
        d="M9.12801 15.4874C8.78812 15.4874 8.51259 15.7629 8.51259 16.1028C8.51259 16.4427 8.78812 16.7183 9.12801 16.7183H14.872C15.2119 16.7183 15.4874 16.4427 15.4874 16.1028C15.4874 15.7629 15.2119 15.4874 14.872 15.4874H9.12801Z"
        fill="currentColor"
      />
    </svg>
  );
};
